<app-toolbar></app-toolbar>

<app-header title="Impressum">
  <markant-button app-go-back>Zurück</markant-button>
</app-header>
<div class="cream">
  <div class="container">
    <div class="containerFrame">
      <div class="containerFrameInner">
        <header>
          <h1 class="">Impressum</h1>
        </header>
        <p>&nbsp;</p>
        <h3>Verantwortlich für den Inhalt:</h3>

        Markant Deutschland GmbH<br />
        Serviceunternehmen der Markant AG<br />
        Hanns-Martin-Schleyer-Straße 2<br />
        77656 Offenburg<br />
        DEUTSCHLAND<br />

        <p>
          Telefon: +49 781 616-0<br />
          Telefax: +49 781 616-166<br />
          E-Mail: info&#64;de.markant.com<br />
        </p>

        <p>Geschäftsführer: John Grewe</p>
        <p>&nbsp;</p>
        <h2>Haftung für Inhalte</h2>

        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10
          TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>

        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
          diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
          Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>
        <p>&nbsp;</p>
        <h2>Haftung für Links</h2>

        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte
          auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
          verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
          nicht erkennbar.
        </p>

        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
        <p>&nbsp;</p>
        <h2>Urheberrecht</h2>

        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
          Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>

        <p>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
          Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden
          Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>
        <p>&nbsp;</p>
        <h2>Urheberrechte des Bildmaterials</h2>

        <p style="margin-bottom: 0em">Sämtliche Rechte an Bildmaterialien soweit nicht zusätzlich erworben, liegen bei der Markant AG.</p>
      </div>
    </div>
  </div>
</div>
